import React, { Component } from 'react';

class Header extends Component {
   render() {
      const { data } = this.props
      if (data) {
         var name = data.name;
         var occupation = data.occupation;
         var description = data.description;
         var networks = data.social.map(function (network) {
            return <li key={network.name}><a href={network.url}><i className={network.className}></i></a></li>
         })
      }

      return (
         <header id="home">

            <nav id="nav-wrap">

               <a className="mobile-btn" href="#nav-wrap" title="Show navigation">Show navigation</a>
               <a className="mobile-btn" href="#home" title="Hide navigation">Hide navigation</a>

               <ul id="nav" className="nav">
                  <li className="current"><a className="smoothscroll" href="#home">ホーム</a></li>
                  <li><a className="smoothscroll" href="#about">経歴</a></li>
                  <li><a className="smoothscroll" href="#resume">職歴</a></li>
                  <li><a className="smoothscroll" href="#portfolio">プロジェクト</a></li>
                  {/* Testimonials */}
                  <li><a className="smoothscroll" href="#cert">免許・資格</a></li>
                  <li><a className="smoothscroll" href="#contact">お問い合わせ</a></li>
               </ul>

            </nav>

            <div className="row banner">
               <div className="banner-text">
                  <h1 className="responsive-headline">{name}</h1>
                  <h3><span>{occupation}</span>.</h3>
                  <h3>{description}.</h3>
                  <hr />
                  <ul className="social">
                     {networks}
                  </ul>
               </div>
            </div>

            <p className="scrolldown">
               <a className="smoothscroll" href="#about"><i className="icon-down-circle"></i></a>
            </p>

         </header>
      );
   }
}

export default Header;
